"use client";

import { css } from "@/../styled-system/css";
import Ban from "@/assets/svg/ban.svg";
import Clock from "@/assets/svg/clock.svg";
import CornerDownLeft from "@/assets/svg/corner-down-left.svg";
import DollarSign from "@/assets/svg/dollar-sign.svg";
import Heart from "@/assets/svg/heart.svg";
import Timer from "@/assets/svg/timer.svg";

const FAQGridClass = css({
  width: "100%",
  display: "grid",
  margin: "0 auto",
  gridTemplateColumns: "repeat(1, 1fr)",
  gridGap: "8",
  sm: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  md: {
    gridTemplateColumns: "repeat(3, 1fr)",
    gridGap: "64px 32px",
  },
});

const iconContainerClass = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "48px",
  height: "48px",
  rounded: "lg",
  boxShadow: "sm",
  borderWidth: "1px",
  borderColor: "gray.200",
});

const FAQList = [
  {
    icon: <CornerDownLeft width="1.5rem" stroke="#41C8E6" />,
    question: "What is the refund policy?",
    answer:
      "If you require assistance with a product, please reach out to us through our contact form below.",
  },
  {
    icon: <Ban width="1.5rem" stroke="#41C8E6" />,
    question: "How do I cancel my subscription?",
    answer:
      "You will be able to manage or cancel your Premium Subscription through the Stripe Customer Portal, which can be accessed from your Profile page.",
  },
  {
    icon: <Clock width="1.5rem" stroke="#41C8E6" />,
    question: "How long do requests usually take to be fulfilled?",
    answer:
      "Depending on the difficulty to acquire, requests can take anywhere between 5-13 business days including shipping to be fulfilled.",
  },
  {
    icon: <Timer width="1.5rem" stroke="#41C8E6" />,
    question:
      "What happens if I don’t purchase my reserved item within 30 days?",
    answer:
      "If you haven’t purchased your reserved item within the 30 day timeframe, you can extend your reservation period another 30 days for a small fee. Otherwise, your reservation will expire and the item will be available for other customers.",
  },
  {
    icon: <Heart width="1.5rem" stroke="#41C8E6" />,
    question: "What type of style does Solecit cater to?",
    answer:
      "Solecit is a style-agnostic platform meaning we cater to any style our customers desire.  Not sure what style is right for you? We are here to help you discover that!",
  },
  {
    icon: <DollarSign width="1.5rem" stroke="#41C8E6" />,
    question: "Can I sell my unwanted items to Solecit?",
    answer:
      "Currently we do not acquire unwanted items from the wardrobes of our customers.",
  },
];

function TopFAQs() {
  return (
    <div className={FAQGridClass}>
      {FAQList.map((FAQ, index) => (
        <div key={index}>
          <div
            className={css({
              mb: "5",
            })}
          >
            <div className={iconContainerClass}>{FAQ.icon}</div>
          </div>
          <div>
            <div className={css({ mb: "2" })}>
              <span
                className={css({
                  fontSize: "xl",
                  fontWeight: "semibold",
                  color: "gray.900",
                })}
              >
                {FAQ.question}
              </span>
            </div>
            <div>
              <p className={css({ color: "slate.600" })}>{FAQ.answer}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TopFAQs;
